import { render, staticRenderFns } from "./AppStatistics.vue?vue&type=template&id=61067ee6&"
import script from "./AppStatistics.vue?vue&type=script&lang=js&"
export * from "./AppStatistics.vue?vue&type=script&lang=js&"
import style0 from "./AppStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports